import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, renderList as _renderList } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "17px"
}
const _hoisted_2 = ["xlink:href"]
const _hoisted_3 = {
  key: 1,
  class: "",
  style: {"padding-left":"37px !important"}
}
const _hoisted_4 = {
  key: 0,
  class: "icon",
  "aria-hidden": "true",
  "font-size": "16px"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_SidebarItemLink = _resolveComponent("SidebarItemLink")!
  const _component_sidebar_item = _resolveComponent("sidebar-item", true)!
  const _component_el_submenu = _resolveComponent("el-submenu")!

  return (!_ctx.item.meta || !_ctx.item.meta.hidden)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([
      _ctx.isCollapse ? 'simple-mode' : 'full-mode',
      { 'first-level': _ctx.isFirstLevel }
    ])
      }, [
        (!_ctx.alwaysShowRootMenu && _ctx.theOnlyOneChild && !_ctx.theOnlyOneChild.children)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.theOnlyOneChild.meta)
                ? (_openBlock(), _createBlock(_component_SidebarItemLink, {
                    key: 0,
                    to: _ctx.resolvePath(_ctx.theOnlyOneChild.path)
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_menu_item, {
                        index: _ctx.resolvePath(_ctx.theOnlyOneChild.path),
                        class: _normalizeClass({ 'submenu-title-noDropdown': _ctx.isFirstLevel })
                      }, {
                        default: _withCtx(() => [
                          (_ctx.theOnlyOneChild.meta.icon)
                            ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [
                                _createElementVNode("use", {
                                  "xlink:href": _ctx.theOnlyOneChild.meta.icon
                                }, null, 8, _hoisted_2)
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.theOnlyOneChild.meta.title)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.theOnlyOneChild.meta.title), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["index", "class"])
                    ]),
                    _: 1
                  }, 8, ["to"]))
                : _createCommentVNode("", true)
            ], 64))
          : (_openBlock(), _createBlock(_component_el_submenu, {
              key: 1,
              index: _ctx.resolvePath(_ctx.item.path)
            }, {
              title: _withCtx(() => [
                (_ctx.item.meta && _ctx.item.meta.icon)
                  ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                      _createElementVNode("use", {
                        "xlink:href": _ctx.item.meta.icon
                      }, null, 8, _hoisted_5)
                    ]))
                  : _createCommentVNode("", true),
                (
            _ctx.item.meta && _ctx.item.meta.iconName && _ctx.item.meta.iconName === 'lpoa'
          )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: _normalizeClass([_ctx.isCollapse ? 'menu-icon-coll' : '', 'menu-icon']),
                      src: _ctx.lpoa
                    }, null, 10, _hoisted_6))
                  : _createCommentVNode("", true),
                (
            _ctx.item.meta && _ctx.item.meta.iconName && _ctx.item.meta.iconName === 'currency'
          )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: _normalizeClass([_ctx.isCollapse ? 'menu-icon-coll' : '', 'menu-icon']),
                      src: _ctx.currency
                    }, null, 10, _hoisted_7))
                  : _createCommentVNode("", true),
                (_ctx.item.meta && _ctx.item.meta.title)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.item.meta.title), 1))
                  : _createCommentVNode("", true)
              ]),
              default: _withCtx(() => [
                (_ctx.item.children)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.item.children, (child) => {
                      return (_openBlock(), _createBlock(_component_sidebar_item, {
                        key: child.path,
                        item: child,
                        "is-collapse": _ctx.isCollapse,
                        "is-first-level": false,
                        "base-path": _ctx.resolvePath(child.path),
                        class: "nest-menu"
                      }, null, 8, ["item", "is-collapse", "base-path"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["index"]))
      ], 2))
    : _createCommentVNode("", true)
}